// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"379":"7e210455","781":"698c4894"}[chunkId] + ".js";
};